// Cave84 — App shell (Phase 0 Day 3)
// Layout for every authenticated route. The auth gate itself lives in App.tsx
// (the entire router only mounts when status === 'authenticated'), so this
// shell can assume an authenticated user is present.

import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { BottomNav } from './BottomNav';
import { AddBottleFAB } from './AddBottleFAB';

export function AppShell() {
  return (
    <div className="relative z-10 min-h-screen flex flex-col">
      <TopBar />
      {/* pb on mobile keeps the BottomNav from covering content; --bulk-bar-h
          is set by the Inventory BulkActionBar while a selection is active */}
      <main className="flex-1 pb-[calc(5rem+var(--bulk-bar-h,0px))] md:pb-[calc(2.5rem+var(--bulk-bar-h,0px))]">
        <Outlet />
      </main>
      <BottomNav />
      <AddBottleFAB />
    </div>
  );
}
